let localStorage;

if (!import.meta.env.IS_SERVER) {
  localStorage = window.localStorage;
}
else {
  localStorage = {
    getItem: () => null,
    setItem: () => null,
    removeItem: () => null,
    clear: () => null,
  };
}


export default localStorage;
